/* global G */
import find from 'lib/sequence/component/children/find'
import { get } from 'lib/sequence/component/state/value'
import { hide } from 'lib/sequence/component/state/hidden'

/**
 * Hides the status component with a key of `component` if its status is contained in
 * `excludedStatuses`.
 *
 * @param {Object} p
 * @param {?string} p.component          name of the status component
 * @param {?string} p.parent            optional name of the parent container in case its
 *                                      name is not unique
 * @param {?number[]} p.excludedStatuses list of statuses that should not be shown
 * @returns {function(Gaia.AppModule.Spec): function(...[*]): Promise<*[]>}
 */
export default ({ component = 'status', parent = null, excludedStatuses = [50] } = {}) => module => async (components, ...args) => {
  const { [parent]: parentComponent } = components || {}
  const {
    [component]: targetComponent,
  } = find(parentComponent || module[G.STATE][G.ACTION][G.COMPONENT])

  if (targetComponent && excludedStatuses.includes(get(targetComponent))) {
    hide(targetComponent)
  }

  return [components, ...args]
}
